<div class="row">
    <div class="col-md-12">
        <dx-data-grid [dataSource]="dataSource" (onInitNewRow)="onInitNewRow($event)"
            (onContentReady)="onContentReady($event)" (onToolbarPreparing)="onToolbarPreparing($event)">
            <dxo-filter-row></dxo-filter-row>

            <dxo-search-panel placeholder="Suche..." [width]="300" [visible]="true"></dxo-search-panel>

            <div *dxTemplate="let data of 'searchBarTemplate1'">
                <div class="toolBarTemplateContainer">
                    <dx-check-box class="toolBarTemplateItem" text="Nur meine anzeigen" [value]="onlySelfResults"
                        (onValueChanged)="onOnlySelfResultsValueChanged($event)">
                    </dx-check-box>
                </div>
            </div>

            <dxo-editing mode="form" [allowUpdating]="allowEdit && !disabled" [allowDeleting]="allowEdit" [allowAdding]="!disabled"
                [useIcons]="true">
                <dxo-texts confirmDeleteMessage="Wiedervorlage wirklich erledigt?"></dxo-texts>
                <dxo-form [colCount]="1" [labelLocation]="'top'">
                    <dxi-item itemType="group">
                        <dxi-item [colSpan]="1" dataField="benutzerId"
                            [validationRules]="[{type: 'required'}]"></dxi-item>
                        <dxi-item [colSpan]="1" dataField="termin" [validationRules]="[{type: 'required'}]"></dxi-item>
                        <dxi-item [colSpan]="1" dataField="grundId" editorType="dxSelectBox"
                            [validationRules]="[{type: 'required'}]"
                            [editorOptions]="{items: gruende, displayExpr: 'name', valueExpr: 'id', acceptCustomValue: true, onCustomItemCreating: addCustomItem}"></dxi-item>
                        <dxi-item [colSpan]="1" dataField="betreff" [validationRules]="[{type: 'required'}]"></dxi-item>
                    </dxi-item>
                </dxo-form>
            </dxo-editing>

            <dxi-column type="buttons">
                <dxi-button name="save"></dxi-button>
                <dxi-button name="edit"></dxi-button>
                <dxi-button name="delete" hint="Erledigt" icon="check" cssClass="wiedErledigtButton"></dxi-button>
            </dxi-column>

            <dxi-column dataField="id" [visible]="false"></dxi-column>
            <dxi-column dataField="termin" format="dd.MM.yyyy" dataType="date"></dxi-column>
            <dxi-column dataField="betreff"></dxi-column>
            <dxi-column dataField="benutzerId" caption="Benutzer">
                <dxo-lookup [dataSource]="benutzer" displayExpr="name" valueExpr="id"></dxo-lookup>
            </dxi-column>
            <dxi-column dataField="grundId" caption="Grund">
                <dxo-lookup [dataSource]="gruende" displayExpr="name" valueExpr="id"></dxo-lookup>
            </dxi-column>
        </dx-data-grid>
    </div>
</div>